import { render, staticRenderFns } from "./VerticalDrag.vue?vue&type=template&id=e9524bc8"
import script from "./VerticalDrag.vue?vue&type=script&lang=js"
export * from "./VerticalDrag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9524bc8')) {
      api.createRecord('e9524bc8', component.options)
    } else {
      api.reload('e9524bc8', component.options)
    }
    module.hot.accept("./VerticalDrag.vue?vue&type=template&id=e9524bc8", function () {
      api.rerender('e9524bc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal/VerticalDrag.vue"
export default component.exports